var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6003 10.2378C12.7522 10.3902 12.8661 10.5763 12.9327 10.7808C12.9993 10.9854 13.0168 11.2028 12.9837 11.4154C12.9507 11.628 12.8681 11.8299 12.7425 12.0046C12.617 12.1793 12.452 12.322 12.2611 12.4211C11.1698 13.0044 9.89832 13.1535 8.70173 12.8384C5.5259 12.0389 0.961056 7.4741 0.161574 4.29827C-0.153459 3.10168 -0.00439477 1.83022 0.578864 0.738945C0.677985 0.547981 0.820684 0.383044 0.995407 0.257489C1.17013 0.131934 1.37197 0.0492908 1.58457 0.0162514C1.79717 -0.0167881 2.01457 0.000704932 2.21916 0.067314C2.42374 0.133923 2.60977 0.247776 2.76217 0.399653L4.11739 1.75422C4.31282 1.9477 4.44507 2.19583 4.4967 2.46594C4.54833 2.73606 4.51693 3.01547 4.40663 3.26739C4.28593 3.55003 4.11455 3.8082 3.90094 4.02917C2.35138 5.57874 7.42191 10.6493 8.97083 9.09906C9.19183 8.88469 9.45024 8.71264 9.73326 8.59142C9.98514 8.48094 10.2646 8.44944 10.5348 8.50108C10.8049 8.55272 11.0531 8.68507 11.2464 8.88066L12.6003 10.2378Z",
    fill: "#14A83D",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneGreen);
export default __webpack_public_path__ + "static/media/phone-green.2e756c5b4dba71a73a94122ff19334a4.svg";
export { ForwardRef as ReactComponent };